import { NSAHomePage, NSARouterMakerResult } from 'namirasoft-account-react';
import { HistoryLayout } from '../HistoryLayout';
import { HistoryRouterProps } from '../HistoryRouterProps';

interface HomePageProps extends NSARouterMakerResult, HistoryRouterProps { }

export default function HomePage(props: HomePageProps)
{
    return (
        <HistoryLayout
            {...props}
        >
            <NSAHomePage
                {...props}
            />
        </HistoryLayout>
    );
}